/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// product tabs
document.addEventListener('DOMContentLoaded', function () {
  // Step 1: Parse product variants data from JSON and log for testing
  var productJsonScript = document.querySelector('script[data-product-json]');
  if (productJsonScript) {
    try {
      var productData = JSON.parse(productJsonScript.textContent);
      window.productData = productData; // Make globally accessible
      var variants = productData.product.variants;
      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');
        console.log('[Step 1 Test] Product variants:', variants);
      }
    } catch (e) {
      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');
        console.error('Failed to parse product JSON:', e);
      }
    }
  } else {
    if (document.querySelector('[data-dev-mode]')) {
      console.warn('---Dev Mode Logging---');
      console.log('No product JSON found on page.');
    }
  }

  document.querySelectorAll('.product-block-list__tabs_navigation a').forEach(function (tabLink) {
    tabLink.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      // Remove the selected class from all tabs
      document
        .querySelector('.product-block-list__tabs_navigation a.selected')
        ?.classList.remove('selected');

      // Hide all tab contents
      document.querySelectorAll('.product-block-list__tab').forEach(function (tabContent) {
        tabContent.style.display = 'none';
      });

      // Add selected class to the clicked tab
      tabLink.classList.add('selected');

      // Show the corresponding tab content
      document.querySelector(tabLink.getAttribute('href')).style.display = 'block';
    });
  });

  document.querySelector('.product-tab--description')?.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    // Get the first tab link
    var firstTabLink = document.querySelector(
      '.product-block-list__tabs_navigation ul li:first-child a'
    );

    // Remove the selected class from all tabs
    document
      .querySelector('.product-block-list__tabs_navigation a.selected')
      ?.classList.remove('selected');

    // Hide all tab contents
    document.querySelectorAll('.product-block-list__tab').forEach(function (tabContent) {
      tabContent.style.display = 'none';
    });

    // Add selected class to the first tab
    firstTabLink.classList.add('selected');

    // Show the corresponding tab content
    document.querySelector(firstTabLink.getAttribute('href')).style.display = 'block';

    // Scroll to the product description
    window.scrollTo(0, document.getElementById('product-description').offsetTop);
  });

  // Step 4: Refactor custom dropdown rendering so it can be called externally
  document.querySelectorAll('.custom-variant-dropdown').forEach(function (dropdownWrapper) {
    var optionName = dropdownWrapper.getAttribute('data-for');
    var select = document.querySelector('select[name="' + optionName + '"]');
    if (!select) return;

    // Store the initial width to prevent changes on variant updates
    var initialWidth = null;
    // Track if this is the initial page load

    // Attach the render function to the select for external calls
    select.renderCustomDropdown = function () {
      // Clear the placeholder and create the real dropdown
      dropdownWrapper.innerHTML = '';
      var selectedValue = select.value;
      var options = Array.from(select.options);
      var dropdown = document.createElement('div');
      dropdown.className = 'custom-dropdown';

      var selected = options.find(function (opt) {
        return opt.selected;
      });
      var isInitialLoad = dropdownWrapper.classList.contains('no-selection');
      // On initial load, show "Please select" regardless of default selection
      var selectedLabel = isInitialLoad ? 'Please select' : selected ? selected.textContent : '';
      var selectedDiv = document.createElement('div');
      selectedDiv.className = 'custom-dropdown__selected';
      selectedDiv.textContent = selectedLabel;
      dropdown.appendChild(selectedDiv);

      var list = document.createElement('ul');
      list.className = 'custom-dropdown__list';
      options.forEach(function (option, idx) {
        var li = document.createElement('li');
        li.className = 'custom-dropdown__option';
        li.textContent = option.textContent;
        li.setAttribute('data-value', option.value);
        if (option.disabled) {
          li.classList.add('custom-dropdown__option--soldout');
          li.setAttribute('aria-disabled', 'true');
        }
        li.addEventListener('click', function (e) {
          if (option.disabled) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          dropdown.classList.remove('open'); // Close dropdown after selection
        });
        list.appendChild(li);
      });
      dropdown.appendChild(list);

      // Toggle list visibility
      selectedDiv.addEventListener('click', function (e) {
        e.stopPropagation();
        dropdown.classList.toggle('open');
      });
      // Close dropdown on outside click
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('open');
        }
      });

      dropdownWrapper.appendChild(dropdown);

      // Set fixed width after rendering to prevent bold text from changing width
      setTimeout(function () {
        if (initialWidth === null) {
          // First render - calculate width based on longest option text
          var tempDiv = document.createElement('div');
          tempDiv.className = 'custom-dropdown__selected';
          tempDiv.style.position = 'absolute';
          tempDiv.style.visibility = 'hidden';
          tempDiv.style.whiteSpace = 'nowrap';
          document.body.appendChild(tempDiv);

          var maxWidth = 0;
          options.forEach(function (option) {
            tempDiv.textContent = option.textContent;
            maxWidth = Math.max(maxWidth, tempDiv.offsetWidth);
          });

          document.body.removeChild(tempDiv);
          initialWidth = maxWidth + 40; // Add some padding for dropdown arrow and spacing
        }
        // Use the stored initial width for all renders
        dropdown.style.width = initialWidth + 'px';
        dropdown.style.minWidth = initialWidth + 'px';
      }, 0);
    };

    select.renderCustomDropdown();
    select.addEventListener('change', function () {
      dropdownWrapper.classList.remove('no-selection');
      select.renderCustomDropdown();
    });
    dropdownWrapper.addEventListener('forceRerender', function () {
      select.renderCustomDropdown();
    });
  });

  // Helper: Get current selections for all options in order, using correct selector name
  function getCurrentSelections() {
    if (
      !window.productData ||
      !window.productData.options_with_values ||
      !window.productData.product
    )
      return [];
    var optionsWithValues = window.productData.options_with_values;
    var productId = window.productData.product.id;
    // Try to get section id from the first dropdown or swatch
    var sectionId = null;
    var firstSelector = document.querySelector('.product-form__single-selector');
    if (firstSelector && firstSelector.name) {
      var match = firstSelector.name.match(/^(.*)-[0-9]+-[0-9]+$/);
      if (match) sectionId = match[1];
    }
    var selections = [];
    optionsWithValues.forEach(function (option, idx) {
      var optionPosition = option.position || idx + 1;
      var selectorName = sectionId
        ? sectionId + '-' + productId + '-' + optionPosition
        : option.name;
      // Try dropdown first
      var dropdown = document.querySelector(
        '.product-form__single-selector[name="' + selectorName + '"]'
      );
      if (dropdown && dropdown.tagName === 'SELECT') {
        selections.push(dropdown.value);
        if (document.querySelector('[data-dev-mode]')) {
          console.warn('---Dev Mode Logging---');

          console.log('[Step 3 Debug] Selector', selectorName, 'dropdown value:', dropdown.value);
        }
      } else {
        // Try swatch radio
        var checked = document.querySelector(
          'input[type="radio"][name="' + selectorName + '"]:checked'
        );
        if (checked) {
          selections.push(checked.value);
          if (document.querySelector('[data-dev-mode]')) {
            console.warn('---Dev Mode Logging---');

            console.log('[Step 3 Debug] Selector', selectorName, 'swatch value:', checked.value);
          }
        } else {
          selections.push(null);
          if (document.querySelector('[data-dev-mode]')) {
            console.warn('---Dev Mode Logging---');

            console.log('[Step 3 Debug] Selector', selectorName, 'no value');
          }
        }
      }
    });
    if (document.querySelector('[data-dev-mode]')) {
      console.warn('---Dev Mode Logging---');

      console.log('[Step 3 Debug] getCurrentSelections:', selections);
    }
    return selections;
  }

  // Step 3: Update disabled states for all dropdowns
  function updateDropdownDisabledStates() {
    // Check if we have the required data
    if (
      !window.productData ||
      !window.productData.product ||
      !window.productData.product.variants
    ) {
      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');
        console.warn('[Step 3 Error] Missing product data');
      }
      return;
    }

    const variants = window.productData.product.variants;
    const currentSelections = getCurrentSelections();
    if (document.querySelector('[data-dev-mode]')) {
      console.warn('---Dev Mode Logging---');

      console.log('[Step 3 Debug] getCurrentSelections:', currentSelections);
    }

    // Get all dropdowns
    const dropdowns = document.querySelectorAll('.custom-variant-dropdown');

    dropdowns.forEach(dropdown => {
      const select = document.getElementById(dropdown.dataset.for);
      if (!select) return;

      // Get the option position from the select element
      const optionPosition = parseInt(select.dataset.optionPosition) - 1; // Convert to 0-based index
      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');

        console.log(`[Step 3 Debug] Processing dropdown at position ${optionPosition}`);
      }

      const options = Array.from(select.options);
      const disabledOptions = [];

      options.forEach(option => {
        const value = option.value;

        // Create a test selection array that uses current selections but replaces the option being tested
        const testSelections = [...currentSelections];
        testSelections[optionPosition] = value;

        if (document.querySelector('[data-dev-mode]')) {
          console.warn('---Dev Mode Logging---');
          console.log(`[Step 3 Debug] Checking option: ${value} at position ${optionPosition}`, {
            currentSelections,
            testSelections,
            value
          });
        }

        const available = isOptionAvailable(variants, currentSelections, optionPosition, value);
        if (document.querySelector('[data-dev-mode]')) {
          console.warn('---Dev Mode Logging---');
          console.log(`[Step 3 Debug] Option ${value} available:`, available);
        }

        if (!available) {
          disabledOptions.push(value);
        }
      });

      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');
        console.log('[Step 3 Test] Dropdown', select.id, 'disabled options:', disabledOptions);
      }

      // Update the custom dropdown UI
      const customOptions = dropdown.querySelectorAll('.custom-dropdown__option');
      customOptions.forEach(customOption => {
        const isSoldOut = disabledOptions.includes(customOption.dataset.value);
        customOption.classList.toggle('custom-dropdown__option--soldout', isSoldOut);
        customOption.setAttribute('aria-disabled', isSoldOut);
      });
    });
    if (document.querySelector('[data-dev-mode]')) {
      console.warn('---Dev Mode Logging---');

      console.log('[Step 3 Test] Swatch changed, dropdowns updated');
    }
  }

  // Attach event listeners to all variant selectors (dropdowns and swatches)
  var dropdowns = Array.from(document.querySelectorAll('.product-form__single-selector')).filter(
    function (el) {
      return el.tagName === 'SELECT';
    }
  );
  dropdowns.forEach(function (select) {
    select.addEventListener('change', function () {
      document.querySelectorAll('.custom-variant-dropdown').forEach(function (wrapper) {
        var event = new Event('forceRerender');
        wrapper.dispatchEvent(event);
      });
      updateDropdownDisabledStates();
    });
  });
  // Swatch (color) inputs
  var swatchInputs = document.querySelectorAll(
    '.color-swatch__radio, .variant-swatch__radio, .block-swatch__radio'
  );
  swatchInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      document.querySelectorAll('.custom-variant-dropdown').forEach(function (wrapper) {
        var event = new Event('forceRerender');
        wrapper.dispatchEvent(event);
      });
      updateDropdownDisabledStates();
      if (document.querySelector('[data-dev-mode]')) {
        console.warn('---Dev Mode Logging---');

        console.log('[Step 3 Test] Swatch changed, dropdowns updated');
      }
    });
  });
  // Initial update on page load (moved to end to ensure all dropdowns are rendered)
  setTimeout(updateDropdownDisabledStates, 0);
});

// reviews.io

const jumpToReviewsIO = () => {
  const links = document.querySelectorAll('.product-block-list__tabs_navigation > ul > li > a');
  if (links.length > 0) {
    // is product reviews selected, click it!
    if (!links[links.length - 1].classList.contains('selected')) {
      links[links.length - 1].click();
    }
    const target = document.getElementById('product-reviews-io');
    if (target) {
      window.scrollTo({
        top: target.offsetTop,
        behavior: 'smooth'
      });
    }
  }
};

document.querySelectorAll('.ruk_rating_snippet, .ruk_read_reviews').forEach(element => {
  element.addEventListener('click', event => {
    event.preventDefault();
    jumpToReviewsIO();
  });
});

document.querySelectorAll('.ruk_read_reviews').forEach(element => {
  element.addEventListener('click', event => {
    event.preventDefault();
    jumpToReviewsIO();
  });
});

// Function to show the tooltip
function showTooltip(event) {
  const tooltipText = event.target.getAttribute('data-tooltip');

  if (!tooltipText) return;

  // Create tooltip element
  const tooltip = document.createElement('div');
  tooltip.className = 'img-tooltip';
  tooltip.textContent = tooltipText;

  document.body.appendChild(tooltip);

  const targetRect = event.target.getBoundingClientRect();
  const tooltipRect = tooltip.getBoundingClientRect();

  // Scroll position
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // Position the tooltip above the element
  tooltip.style.left = `${targetRect.left + targetRect.width / 2 - tooltipRect.width / 2 + scrollLeft}px`;
  tooltip.style.top = `${targetRect.top + (targetRect.height + 10) + scrollTop}px`;

  // Show tooltip
  tooltip.classList.add('img-tooltip-visible');

  // Store the tooltip element on the target element for future reference
  event.target._tooltipElement = tooltip;
}

// Function to hide the tooltip
function hideTooltip(event) {
  const tooltip = event.target._tooltipElement;
  if (tooltip) {
    tooltip.remove(); // Remove the tooltip from the DOM
    event.target._tooltipElement = null;
  }
}

const uniqueAlts = [
  ...new Set(
    Array.from(document.querySelectorAll('.product-gallery__thumbnail')).map(element => {
      const img = element.querySelector('img');
      return img ? img.getAttribute('alt') : '';
    })
  )
];

document.querySelectorAll('.product-gallery__thumbnail').forEach(element => {
  const img = element.querySelector('img');
  if (img && uniqueAlts.length > 1) {
    img.setAttribute('data-tooltip', img.getAttribute('alt'));
    // img.classList.add("tooltip-trigger");
  }
});

// Attach event listeners to the tooltip triggers
document.querySelectorAll('.tooltip-trigger').forEach(trigger => {
  trigger.addEventListener('mouseenter', showTooltip);
  trigger.addEventListener('mouseleave', hideTooltip);
});

// const checkPdpRefferer = () => {
//   // Get the query string from the referrer
//   const referrerQueryString = document.referrer.split('?')[1] || '';
//   if (!referrerQueryString) return;
//   // Split the query string into an array
//   const splitString = referrerQueryString.split('&');
//   // Get all the product options
//   const productOptions = document.querySelectorAll('.product-form__option');
//   // Loop through all the product options
//   productOptions.forEach(productOption => {
//     // Get the option name and the selectors
//     const optionName = productOption
//       .querySelector('.product-form__option-name')
//       .childNodes[0].nodeValue.replace(':', '')
//       .toLowerCase()
//       .trim();
//     const optionSelectors = productOption.querySelectorAll('.product-form__single-selector');

//     // We need to compare the option name to the query string
//     // Then get the relevant value and select it
//     splitString.forEach(queryString => {
//       // Split the query string into an array
//       const query = queryString.split('=');
//       // Size and Colour need remapping
//       const facetName = query[0]
//         .toLowerCase()
//         .replace('custom_clothing_size', 'size')
//         .replace('custom_colour', 'colour');

//       // Check if the query string matches the option name
//       if (facetName === optionName) {
//         // Get the option value
//         const optionValue = query[1];

//         // Loop through all the selectors and select the option
//         optionSelectors.forEach(optionSelector => {
//           if (optionSelector.nodeName === 'SELECT') {
//             optionSelector.value = optionValue;
//           } else if (optionSelector.nodeName === 'INPUT') {
//             // Check if the option selector matches the option value
//             if (optionSelector.dataset.handle === optionValue) {
//               // Click the label
//               optionSelector.nextElementSibling.click();
//             }
//           }
//         });
//       }
//     });
//   });
// };
// if (window.location.href.includes('product')) {
//   checkPdpRefferer();
// }

// Step 2: Utility function to check if an option value is available for the current selection
function isOptionAvailable(variants, currentSelections, optionIndex, value) {
  // Create a test selection array that uses the current selections but replaces the option being tested
  const testSelections = [...currentSelections];
  testSelections[optionIndex] = value;

  // Check if any variant matches this combination and is available
  return variants.some(function (variant) {
    // Check if this variant matches our test selections
    const matches = testSelections.every((selection, index) => {
      // If we have a selection for this index, check if it matches
      if (selection != null) {
        return variant['option' + (index + 1)] === selection;
      }
      // If no selection, consider it a match
      return true;
    });

    // Only return true if the variant matches AND is available
    return matches && variant.available;
  });
}

// Step 2 Test: Example usage (run in console to verify)
document.addEventListener('DOMContentLoaded', function () {
  if (window.productData && window.productData.product && window.productData.product.variants) {
    var variants = window.productData.product.variants;
    // Example: Check if 'M - 39.5-41" Chest' is available for option2 when option1 is 'Deep Fjord'
    var test1 = isOptionAvailable(variants, ['Deep Fjord', null], 1, 'M - 39.5-41" Chest');
    var test2 = isOptionAvailable(variants, ['Patrol Orange', null], 1, 'XL - 44-47" Chest');
    var test3 = isOptionAvailable(variants, ['Olive Green', null], 1, 'XL - 44-47" Chest');
    if (document.querySelector('[data-dev-mode]')) {
      console.warn('---Dev Mode Logging---');

      console.log('[Step 2 Test] Deep Fjord + M:', test1); // Should be false if unavailable
      console.log('[Step 2 Test] Patrol Orange + XL:', test2); // Should be true if available
      console.log('[Step 2 Test] Olive Green + XL:', test3); // Should be false if unavailable
    }
  }
});
